// extracted by mini-css-extract-plugin
export var cta_navigation = "styles-module--cta_navigation--0fcd1";